import bootstrap from "../assets/bootstrap.png";
import python from "../assets/python.png";
import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import docker from "../assets/docker.png";
import flask from "../assets/flask.png";
import figma from "../assets/figma.png";
import mysql from "../assets/mysql.png";
import react from "../assets/react.png";
import git from "../assets/git.png";
import vue from "../assets/vue.png";

import bootstrapb from "../assets/bootstrap-2.png";
import pythonb from "../assets/python-2.png";
import htmlb from "../assets/html-2.png";
import cssb from "../assets/css-2.png";
import javascriptb from "../assets/javascript-2.png";
import dockerb from "../assets/docker-2.png";
import flaskb from "../assets/flask-2.png";
import figmab from "../assets/figma-2.png";
import mysqlb from "../assets/mysql-2.png";
import reactb from "../assets/react-2.png";
import gitb from "../assets/git-2.png";
import vueb from "../assets/vue-2.png";

export const skills = [
  [html, htmlb],
  [css, cssb],
  [javascript, javascriptb],
  [python, pythonb],
  [flask, flaskb],
  [react, reactb],
  [vue, vueb],
  [git, gitb],
  [figma, figmab],
  [bootstrap, bootstrapb],
  [mysql, mysqlb],
  [docker, dockerb],
]
